import { useEffect, useState } from "react"
import { EmptyString, StatusCodeActive } from "utils/Constant"
import ShowerIcon from "assets/icon/ShowerIcon";
import UserIcon from "assets/icon/UserIcon";
import ParkingIcon from "assets/icon/ParkingIcon";
import TVIcon from "assets/icon/TVIcon";
import { BookingService } from "services/BookingService";
import { useModal } from "utils/context/ModalContext";
import { MainBodyCard } from "components/Cards/MainBodyCard";

export default function Rooms(){
    const { fetchBookingList } = BookingService()

    const { showFail, showLoading, hideLoading, showSuccess, confirm } = useModal()

    const [status101, setStatus101] = useState("Available")
    const [tenant101, setTenant101] = useState("None")
    const [status102, setStatus102] = useState("Available")
    const [tenant102, setTenant102] = useState("None")
    const [status103, setStatus103] = useState("Available")
    const [tenant103, setTenant103] = useState("None")
    const [status104, setStatus104] = useState("Available")
    const [tenant104, setTenant104] = useState("None")
    const [status105, setStatus105] = useState("Available")
    const [tenant105, setTenant105] = useState("None")
    const [status106, setStatus106] = useState("Available")
    const [tenant106, setTenant106] = useState("None")
    const [status107, setStatus107] = useState("Available")
    const [tenant107, setTenant107] = useState("None")
    const [status201, setStatus201] = useState("Available")
    const [tenant201, setTenant201] = useState("None")
    const [status202, setStatus202] = useState("Available")
    const [tenant202, setTenant202] = useState("None")
    const [status203, setStatus203] = useState("Available")
    const [tenant203, setTenant203] = useState("None")
    const [status204, setStatus204] = useState("Available")
    const [tenant204, setTenant204] = useState("None")
    const [status205, setStatus205] = useState("Available")
    const [tenant205, setTenant205] = useState("None")
    const [status206, setStatus206] = useState("Available")
    const [tenant206, setTenant206] = useState("None")
    const [status207, setStatus207] = useState("Available")
    const [tenant207, setTenant207] = useState("None")
    const [status208, setStatus208] = useState("Available")
    const [tenant208, setTenant208] = useState("None")
    const [status209, setStatus209] = useState("Available")
    const [tenant209, setTenant209] = useState("None")
    const [status210, setStatus210] = useState("Available")
    const [tenant210, setTenant210] = useState("None")
    const [status211, setStatus211] = useState("Available")
    const [tenant211, setTenant211] = useState("None")
    const [status212, setStatus212] = useState("Available")
    const [tenant212, setTenant212] = useState("None")
    const [status301, setStatus301] = useState("Available")
    const [tenant301, setTenant301] = useState("None")
    const [status302, setStatus302] = useState("Available")
    const [tenant302, setTenant302] = useState("None")
    const [status303, setStatus303] = useState("Available")
    const [tenant303, setTenant303] = useState("None")
    const [status304, setStatus304] = useState("Available")
    const [tenant304, setTenant304] = useState("None")
    const [status305, setStatus305] = useState("Available")
    const [tenant305, setTenant305] = useState("None")
    const [status306, setStatus306] = useState("Available")
    const [tenant306, setTenant306] = useState("None")
    const [status307, setStatus307] = useState("Available")
    const [tenant307, setTenant307] = useState("None")
    const [status308, setStatus308] = useState("Available")
    const [tenant308, setTenant308] = useState("None")
    const [status309, setStatus309] = useState("Available")
    const [tenant309, setTenant309] = useState("None")
    const [status310, setStatus310] = useState("Available")
    const [tenant310, setTenant310] = useState("None")
    const [status311, setStatus311] = useState("Available")
    const [tenant311, setTenant311] = useState("None")
    const [status312, setStatus312] = useState("Available")
    const [tenant312, setTenant312] = useState("None")

    const getBookingList = async () => {
        const res = await fetchBookingList(
            EmptyString,
            EmptyString,
            StatusCodeActive,
            '',
            StatusCodeActive,
            1000,
            parseInt(0),
        )

        return res
    }

    function fCheckStatus(data){
        if (data !== null && typeof(data) !== 'undefined'){
            for(let i = 0; i < data.length; i++){
                if(data[i].roomNumber === "101"){
                    setStatus101("Occupied")
                    setTenant101(data[i].tenantName)
                }else if (data[i].roomNumber === "102"){
                    setStatus102("Occupied")
                    setTenant102(data[i].tenantName)
                }else if (data[i].roomNumber === "103"){
                    setStatus103("Occupied")
                    setTenant103(data[i].tenantName)                    
                }else if (data[i].roomNumber === "104"){
                    setStatus104("Occupied")
                    setTenant104(data[i].tenantName)                    
                }else if (data[i].roomNumber === "105"){
                    setStatus105("Occupied")
                    setTenant105(data[i].tenantName)                    
                }else if (data[i].roomNumber === "106"){
                    setStatus106("Occupied")
                    setTenant106(data[i].tenantName)                    
                }else if (data[i].roomNumber === "107"){
                    setStatus107("Occupied")
                    setTenant107(data[i].tenantName)                    
                }else if (data[i].roomNumber === "201"){
                    setStatus201("Occupied")
                    setTenant201(data[i].tenantName)                    
                }else if (data[i].roomNumber === "202"){
                    setStatus202("Occupied")
                    setTenant202(data[i].tenantName)                    
                }else if (data[i].roomNumber === "203"){
                    setStatus203("Occupied")
                    setTenant203(data[i].tenantName)                    
                }else if (data[i].roomNumber === "204"){
                    setStatus204("Occupied")
                    setTenant204(data[i].tenantName)                    
                }else if (data[i].roomNumber === "205"){
                    setStatus205("Occupied")
                    setTenant205(data[i].tenantName)                    
                }else if (data[i].roomNumber === "206"){
                    setStatus206("Occupied")
                    setTenant206(data[i].tenantName)                    
                }else if (data[i].roomNumber === "207"){
                    setStatus207("Occupied")
                    setTenant207(data[i].tenantName)                    
                }else if (data[i].roomNumber === "208"){
                    setStatus208("Occupied")
                    setTenant208(data[i].tenantName)                    
                }else if (data[i].roomNumber === "209"){
                    setStatus209("Occupied")
                    setTenant209(data[i].tenantName)                    
                }else if (data[i].roomNumber === "210"){
                    setStatus210("Occupied")
                    setTenant210(data[i].tenantName)                    
                }else if (data[i].roomNumber === "211"){
                    setStatus211("Occupied")
                    setTenant211(data[i].tenantName)                    
                }else if (data[i].roomNumber === "212"){
                    setStatus212("Occupied")
                    setTenant212(data[i].tenantName)                    
                }else if (data[i].roomNumber === "301"){
                    setStatus301("Occupied")
                    setTenant301(data[i].tenantName)                    
                }else if (data[i].roomNumber === "302"){
                    setStatus302("Occupied")
                    setTenant302(data[i].tenantName)                    
                }else if (data[i].roomNumber === "303"){
                    setStatus303("Occupied")
                    setTenant303(data[i].tenantName)                    
                }else if (data[i].roomNumber === "304"){
                    setStatus304("Occupied")
                    setTenant304(data[i].tenantName)                    
                }else if (data[i].roomNumber === "305"){
                    setStatus305("Occupied")
                    setTenant305(data[i].tenantName)                    
                }else if (data[i].roomNumber === "306"){
                    setStatus306("Occupied")
                    setTenant306(data[i].tenantName)                    
                }else if (data[i].roomNumber === "307"){
                    setStatus307("Occupied")
                    setTenant307(data[i].tenantName)                    
                }else if (data[i].roomNumber === "308"){
                    setStatus308("Occupied")
                    setTenant308(data[i].tenantName)                    
                }else if (data[i].roomNumber === "309"){
                    setStatus309("Occupied")
                    setTenant309(data[i].tenantName)                    
                }else if (data[i].roomNumber === "310"){
                    setStatus310("Occupied")
                    setTenant310(data[i].tenantName)                    
                }else if (data[i].roomNumber === "311"){
                    setStatus311("Occupied")
                    setTenant311(data[i].tenantName)                    
                }else if (data[i].roomNumber === "312"){
                    setStatus312("Occupied")
                    setTenant312(data[i].tenantName)
                }
            }
        }
    }

    useEffect(() => {
        const onLoad = async () => {
            try {
                showLoading()

                const res = await getBookingList()
                const data = res.data.listData

                fCheckStatus(data)
            } finally {
                hideLoading()
            }
        }

        onLoad()
    }, [])

    return(
        <MainBodyCard>
            <div>
                <span className="font-semibold text-2xl">Rooms</span>
            </div>
            <hr />

            <div className="bg-white p-4 rounded-md">
                <div className="flex justify-center">
                    <span className="font-semibold text-md sm:text-xl">Room Summary</span>
                </div>
                

                <div>
                    <span className="font-semibold text-md">First Floor</span>
                    <div>
                        {/* {bookingList?.data?.listData?.map((data, i) => {
                            if (data.roomNumber.substring(0,1) === "2"){
                                return(
                                    <div>
                                        {data.roomNumber}
                                    </div>
                                )
                            }else{
                                return(
                                    <div />
                                )
                            }
                        })} */}
                    </div>
                    
                </div>

                <div>
                    <span className="font-semibold text-md">Second Floor</span>
                </div>

                <div>
                    <span className="font-semibold text-md">Third Floor</span>
                </div>
            </div>
            
            <div className="flex justify-center gap-4 bg-white p-4">
                <div>
                    <div className="flex justify-center">
                        <span className="font-semibold text-md sm:text-xl">Detail Layout Delala Kost & Guest House</span>
                    </div>
                    <div className="mt-2">
                        <span className="font-semibold text-xl">First Floor</span>
                    </div>                    

                    <div className="flex flex-col border-4 border-double mt-4">
                        <div className="flex">
                            <div className="w-24 ">
                                
                            </div>
                            <div className="flex flex-col w-48 mt-12">
                                <div className={`${status107 === "Occupied" ? 'bg-slate-400' : ''} flex flex-col justify-center items-center w-48 h-48 border-x-4 border-t-4 border-double`}>
                                    <span className="font-semibold text-2xl">107</span>
                                    <div>
                                        <span className="text-sm">{status107.toUpperCase()}</span>
                                    </div>
                                    <div className="flex items-center px-4 w-full">
                                        <UserIcon className="fill-black w-8" />
                                        <div className="max-w-32 whitespace-nowrap text-ellipsis overflow-hidden">
                                            <span className="text-sm">{tenant107.toUpperCase()}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="flex w-48 h-24">
                                    <div className={`${status107 === "Occupied" ? 'bg-slate-400' : ''} flex flex-col justify-center items-center w-24 h-24 border-x-4 border-b-4 border-double`}>
                                        <ShowerIcon />
                                        <span className="text-sm">Bathroom</span>
                                    </div>
                                    <div className={`${status106 === "Occupied" ? 'bg-slate-400' : ''} flex flex-col justify-center items-center w-24 h-24 border-x-4 border-t-4 border-double`}>
                                        <ShowerIcon />
                                        <span className="text-sm">Bathroom</span>
                                    </div>
                                </div>
                                <div className={`${status106 === "Occupied" ? 'bg-slate-400' : ''} flex flex-col justify-center items-center w-48 h-48 border-x-4 border-b-4 border-double`}>
                                    <span className="font-semibold text-2xl">106</span>
                                    <div>
                                        <span className="text-sm">{status106.toUpperCase()}</span>
                                    </div>
                                    <div className="flex items-center px-4">
                                        <UserIcon className="fill-black w-8" />
                                        <div className="max-w-32 whitespace-nowrap text-ellipsis overflow-hidden">
                                            <span className="text-sm">{tenant106.toUpperCase()}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className={`${status105 === "Occupied" ? 'bg-slate-400' : ''} flex flex-col justify-center items-center w-48 h-48 border-x-4 border-t-4 border-double`} >
                                    <span className="font-semibold text-2xl">105</span>
                                    <div>
                                        <span className="text-sm">{status105.toUpperCase()}</span>
                                    </div>
                                    <div className="flex items-center px-4">
                                        <UserIcon className="fill-black w-8" />
                                        <div className="max-w-32 whitespace-nowrap text-ellipsis overflow-hidden">
                                            <span className="text-sm">{tenant105.toUpperCase()}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="flex w-48 h-24">
                                    <div className={`${status105 === "Occupied" ? 'bg-slate-400' : ''} flex flex-col justify-center items-center w-24 h-24 border-x-4 border-b-4 border-double`}>
                                        <ShowerIcon />
                                        <span className="text-sm">Bathroom</span>
                                    </div>
                                    <div className="flex flex-col justify-center items-center w-24 h-24 border-4 border-double">
                                        <ShowerIcon />
                                        <span className="text-sm">Bathroom</span>
                                    </div>
                                </div>
                            </div>
                            <div className="w-48 mt-12">
                                <div className="flex items-center justify-center w-48 h-24 border-4 border-double">
                                    Tangga 
                                </div>
                                <div className={`${status103 === "Occupied" ? 'bg-slate-400' : ''} flex flex-col justify-center items-center w-48 h-48 border-x-4 border-t-4 border-double`}>
                                    <span className="font-semibold text-2xl">103</span>
                                    <div>
                                        <span className="text-sm">{status103.toUpperCase()}</span>
                                    </div>
                                    <div className="flex items-center px-4">
                                        <UserIcon className="fill-black w-8" />
                                        <div className="max-w-32 whitespace-nowrap text-ellipsis overflow-hidden">
                                            <label className="text-sm">{tenant103.toUpperCase()}</label>
                                        </div>
                                    </div>
                                </div>
                                <div className="flex w-48 h-48">
                                    <div className="flex flex-col w-24 h-48 border-l-4  border-double">
                                        <div className={`${status103 === "Occupied" ? 'bg-slate-400' : ''} flex flex-col justify-center items-center w-24 h-24 border-b-4 border-double`}>
                                            <ShowerIcon />
                                            <span className="text-sm">Bathroom</span>
                                        </div>
                                        <div className={`${status104 === "Occupied" ? 'bg-slate-400' : ''} flex flex-col justify-center items-center w-24 h-24 border-t-4 border-double`}>
                                            <ShowerIcon />
                                            <span className="text-sm">Bathroom</span>
                                        </div>
                                    </div>
                                    <div className="w-24 h-48 border-y-4 border-t-4 border-l-4 border-double">

                                    </div>
                                </div>
                                <div className={`${status104 === "Occupied" ? 'bg-slate-400' : ''} flex flex-col justify-center items-center w-48 h-48 border-x-4 border-b-4 border-double`}>
                                    <span className="font-semibold text-2xl">104</span>
                                    <div>
                                        <span className="text-sm">{status104.toUpperCase()}</span>
                                    </div>
                                    <div className="flex items-center gap-3">
                                        <UserIcon className="fill-black" />
                                        <div className="max-w-32 whitespace-nowrap text-ellipsis overflow-hidden">
                                            <label className="text-sm">{tenant104.toUpperCase()}</label>
                                        </div>
                                    </div>
                                </div>
                                <div className="flex items-center justify-center w-48 h-24 border-4 border-double">
                                    Tangga
                                </div>
                            </div>
                            <div className="w-24">
                                
                            </div>
                            <div className="w-48">
                                <div className="flex items-center justify-center w-48 h-48 border-4 border-double">
                                    Kitchen
                                </div>
                                <div className={`${status102 === "Occupied" ? 'bg-slate-400' : ''} flex flex-col justify-center items-center w-48 h-48 border-x-4 border-t-4 border-double`}>
                                    <span className="font-semibold text-2xl">102</span>
                                    <div>
                                        <span className="text-sm">{status102.toUpperCase()}</span>
                                    </div>
                                    <div className="flex items-center gap-3">
                                        <UserIcon className="fill-black" />
                                        <div className="max-w-32 whitespace-nowrap text-ellipsis overflow-hidden">
                                            <label className="text-sm">{tenant102.toUpperCase()}</label>
                                        </div>
                                    </div>
                                </div>
                                <div className="flex w-48 h-24 border-x-4 border-double">
                                    <div className={`${status101 === "Occupied" ? 'bg-slate-400' : ''} flex flex-col justify-center items-center w-24 h-24 border-t-4 border-r-4 border-double`}>
                                        <ShowerIcon />
                                        <span>Bathroom</span>
                                    </div>
                                    <div className={`${status102 === "Occupied" ? 'bg-slate-400' : ''} flex flex-col justify-center items-center w-24 h-24 border-b-4 border-l-4 border-double`}>
                                        <ShowerIcon />
                                        <span>Bathroom</span>
                                    </div>
                                </div>
                                <div className={`${status101 === "Occupied" ? 'bg-slate-400' : ''} flex flex-col justify-center items-center w-48 h-48 border-x-4 border-b-4 border-double`}>
                                    <span className="font-semibold text-2xl">101</span>
                                    <div>
                                        <span className="text-sm">{status101.toUpperCase()}</span>
                                    </div>
                                    <div className="flex items-center gap-3">
                                        <UserIcon className="fill-black" />
                                        <div className="max-w-32 whitespace-nowrap text-ellipsis overflow-hidden">
                                            <label className="text-sm">{tenant101.toUpperCase()}</label>
                                        </div>
                                    </div>
                                </div>
                                <div className="flex gap-2 items-center justify-center w-48 h-36 border-4 border-double">
                                    <TVIcon />
                                    <span className="text-sm">Living Area</span>
                                </div>
                            </div>
                            <div className="w-16">
                                
                            </div>
                        </div>
                        <div className="flex items-center justify-center h-[500px]">
                            <ParkingIcon className="w-24" />
                        </div>
                    </div>
                </div>
            </div>

            <div className="flex justify-center gap-4 bg-white p-4">
                <div>
                    <span className="font-semibold text-xl">2nd Floor</span>

                    <div className="flex flex-col border-4 border-double mt-4">
                        <div className="flex">
                            <div className="w-24">
                                <div className="w-24 h-[1105px]">

                                </div>
                                <div className={`${status208 === "Occupied" ? 'bg-slate-400' : ''} flex flex-col justify-center items-center w-24 h-24 border-y-4 border-l-4 border-double`}>
                                    <ShowerIcon />
                                    <span className="text-sm">Bathroom</span>
                                </div>
                                <div className="w-24 h-24 border-r-4 border-double">

                                </div>
                            </div>

                            <div className="flex flex-col w-48 mt-12">
                                <div className={`${status212 === "Occupied" ? 'bg-slate-400' : ''} flex flex-col justify-center items-center w-48 h-48 border-x-4 border-t-4 border-double`}>
                                    <span className="font-semibold text-2xl">212</span>
                                    <div>
                                        <span className="text-sm">{status212.toUpperCase()}</span>
                                    </div>
                                    <div className="flex items-center gap-3">
                                        <div>
                                            <UserIcon className="fill-black" />
                                        </div>
                                        <div className="max-w-32 whitespace-nowrap text-ellipsis overflow-hidden">
                                            <label className="text-sm">{tenant212.toUpperCase()}</label>
                                        </div>
                                    </div>
                                </div>
                                <div className="flex w-48 h-24">
                                    <div className={`${status212 === "Occupied" ? 'bg-slate-400' : ''} flex flex-col justify-center items-center w-24 h-24 border-x-4 border-b-4 border-double`}>
                                        <ShowerIcon />
                                        <span className="text-sm">Bathroom 1</span>
                                    </div>
                                    <div className={`${status211 === "Occupied" ? 'bg-slate-400' : ''} flex flex-col justify-center items-center w-24 h-24 border-x-4 border-t-4 border-double`}>
                                        <ShowerIcon />
                                        <span className="text-sm">Bathroom</span>
                                    </div>
                                </div>
                                <div className={`${status211 === "Occupied" ? 'bg-slate-400' : ''} flex flex-col justify-center items-center w-48 h-48 border-x-4 border-b-4 border-double`}>
                                    <span className="font-semibold text-2xl">211</span>
                                    <div>
                                        <span className="text-sm">{status211.toUpperCase()}</span>
                                    </div>
                                    <div className="flex items-center gap-3">
                                        <UserIcon className="fill-black" />
                                        <div className="max-w-32 whitespace-nowrap text-ellipsis overflow-hidden">
                                            <label className="text-sm">{tenant211.toUpperCase()}</label>
                                        </div>
                                    </div>
                                </div>
                                <div className={`${status210 === "Occupied" ? 'bg-slate-400' : ''} flex flex-col justify-center items-center w-48 h-48 border-x-4 border-t-4 border-double`}>
                                    <span className="font-semibold text-2xl">210</span>
                                    <div>
                                        <span className="text-sm">{status210.toUpperCase()}</span>
                                    </div>
                                    <div className="flex items-center gap-3">
                                        <UserIcon className="fill-black" />
                                        <div className="max-w-32 whitespace-nowrap text-ellipsis overflow-hidden">
                                            <label className="text-sm">{tenant210.toUpperCase()}</label>
                                        </div>
                                    </div>
                                </div>
                                <div className="flex w-48 h-24">
                                    <div className={`${status210 === "Occupied" ? 'bg-slate-400' : ''} flex flex-col justify-center items-center w-24 h-24 border-x-4 border-b-4 border-double`}>
                                        <ShowerIcon />
                                        <span className="text-sm">Bathroom</span>
                                    </div>
                                    <div className={`${status209 === "Occupied" ? 'bg-slate-400' : ''} flex flex-col justify-center items-center w-24 h-24 border-x-4 border-t-4 border-double`}>
                                        <ShowerIcon />
                                        <span className="text-sm">Bathroom</span>
                                    </div>
                                </div>
                                <div className={`${status209 === "Occupied" ? 'bg-slate-400' : ''} flex flex-col justify-center items-center w-48 h-48 border-x-4 border-b-4 border-double`}>
                                    <span className="font-semibold text-2xl">209</span>
                                    <div>
                                        <span className="text-sm">{status209.toUpperCase()}</span>
                                    </div>
                                    <div className="flex items-center gap-3">
                                        <UserIcon className="fill-black" />
                                        <div className="max-w-32 whitespace-nowrap text-ellipsis overflow-hidden">
                                            <label className="text-sm">{tenant209.toUpperCase()}</label>
                                        </div>
                                    </div>
                                </div>

                                <div className="flex items-center justify-center w-48 h-24">
                                     
                                </div>

                                <div className={`${status208 === "Occupied" ? 'bg-slate-400' : ''} flex flex-col justify-center items-center w-48 h-48 border-r-4 border-y-4 border-double`}>
                                    <span className="font-semibold text-2xl">208</span>
                                    <div>
                                        <span className="text-sm">{status208.toUpperCase()}</span>
                                    </div>
                                    <div className="flex items-center gap-3">
                                        <UserIcon className="fill-black" />
                                        <div className="max-w-32 whitespace-nowrap text-ellipsis overflow-hidden">
                                            <label className="text-sm">{tenant208.toUpperCase()}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="w-48 mt-12">
                                <div className="flex items-center justify-center w-48 h-24 border-4 border-double">
                                    Tangga 
                                </div>
                                <div className={`${status206 === "Occupied" ? 'bg-slate-400' : ''} flex flex-col justify-center items-center w-48 h-48 border-x-4 border-t-4 border-double`}>
                                    <span className="font-semibold text-2xl">206</span>
                                    <div>
                                        <span className="text-sm">{status206.toUpperCase()}</span>
                                    </div>
                                    <div className="flex items-center gap-3">
                                        <UserIcon className="fill-black" />
                                        <div className="max-w-32 whitespace-nowrap text-ellipsis overflow-hidden">
                                            <label className="text-sm">{tenant206.toUpperCase()}</label>
                                        </div>
                                    </div>
                                </div>
                                <div className="flex w-48 h-48">
                                    <div className="flex flex-col w-24 h-48 border-l-4  border-double">
                                        <div className={`${status206 === "Occupied" ? 'bg-slate-400' : ''} flex flex-col justify-center items-center w-24 h-24 border-b-4 border-double`}>
                                            <ShowerIcon />
                                            <span className="text-sm">Bathroom</span>
                                        </div>
                                        <div className={`${status207 === "Occupied" ? 'bg-slate-400' : ''} flex flex-col justify-center items-center w-24 h-24 border-t-4 border-double`}>
                                            <ShowerIcon />
                                            <span className="text-sm">Bathroom</span>
                                        </div>
                                    </div>
                                    <div className="w-24 h-48 border-y-4 border-t-4 border-l-4 border-double">

                                    </div>
                                </div>
                                <div className={`${status207 === "Occupied" ? 'bg-slate-400' : ''} flex flex-col justify-center items-center w-48 h-48 border-x-4 border-b-4 border-double`}>
                                    <span className="font-semibold text-2xl">207</span>
                                    <div>
                                        <span className="text-sm">{status207.toUpperCase()}</span>
                                    </div>
                                    <div className="flex items-center gap-3">
                                        <UserIcon className="fill-black" />
                                        <div className="max-w-32 whitespace-nowrap text-ellipsis overflow-hidden">
                                            <label className="text-sm">{tenant207.toUpperCase()}</label>
                                        </div>
                                    </div>
                                </div>
                                <div className="flex items-center justify-center w-48 h-48 border-4 border-double">
                                    Tangga
                                </div>
                                <div className="flex gap-2 items-center justify-center w-48 h-48">
                                    <TVIcon />
                                    <label>Ruang Bersama</label>
                                </div>
                                <div className="flex items-center justify-center w-48 h-24 border-4 border-double">
                                    Balkon
                                </div>
                            </div>
                            <div className="w-24">
                                <div className="flex items-center justify-center w-24 h-[1104px]">
                                    
                                </div>
                                <div className="flex flex-col items-center justify-center w-24 h-48 border-y-4 border-l-4 border-double">
                                    <div className={`${status201 === "Occupied" ? 'bg-slate-400' : ''} flex items-center justify-center w-24 h-24`}>
                                        
                                    </div>
                                    <div className={`${status201 === "Occupied" ? 'bg-slate-400' : ''} flex flex-col justify-center items-center w-24 h-24 border-4 border-double`}>
                                        <ShowerIcon />
                                        <span className="text-sm">Bathroom</span>
                                    </div>
                                </div>
                            </div>
                            <div className="w-48">
                                <div className="w-48 h-[144px]">
                                    
                                </div>
                                <div className={`${status205 === "Occupied" ? 'bg-slate-400' : ''} flex flex-col justify-center items-center w-48 h-48 border-x-4 border-t-4 border-double`}>
                                    <span className="font-semibold text-2xl">205</span>
                                    <div>
                                        <span className="text-sm">{status205.toUpperCase()}</span>
                                    </div>
                                    <div className="flex items-center gap-3">
                                        <UserIcon className="fill-black" />
                                        <div className="max-w-32 whitespace-nowrap text-ellipsis overflow-hidden">
                                            <label className="text-sm">{tenant205.toUpperCase()}</label>
                                        </div>
                                    </div>
                                </div>
                                <div className="flex w-48 h-24 border-x-4 border-double">
                                    <div className={`${status204 === "Occupied" ? 'bg-slate-400' : ''} flex flex-col justify-center items-center w-24 h-24 border-t-4 border-r-4 border-double`}>
                                        <ShowerIcon />
                                        <span className="text-sm">Bathroom</span>
                                    </div>
                                    <div className={`${status205 === "Occupied" ? 'bg-slate-400' : ''} flex flex-col justify-center items-center w-24 h-24 border-b-4 border-l-4 border-double`}>
                                        <ShowerIcon />
                                        <span className="text-sm">Bathroom</span>
                                    </div>
                                </div>
                                <div className={`${status204 === "Occupied" ? 'bg-slate-400' : ''} flex flex-col justify-center items-center w-48 h-48 border-x-4 border-b-4 border-double`}>
                                    <span className="font-semibold text-2xl">204</span>
                                    <div>
                                        <span className="text-sm">{status204.toUpperCase()}</span>
                                    </div>
                                    <div className="flex items-center gap-3">
                                        <UserIcon className="fill-black" />
                                        <div className="max-w-32 whitespace-nowrap text-ellipsis overflow-hidden">
                                            <label className="text-sm">{tenant204.toUpperCase()}</label>
                                        </div>
                                    </div>
                                </div>
                                <div className={`${status203 === "Occupied" ? 'bg-slate-400' : ''} flex flex-col justify-center items-center w-48 h-48 border-x-4 border-t-4 border-double`}>
                                    <span className="font-semibold text-2xl">203</span>
                                    <div>
                                        <span className="text-sm">{status203.toUpperCase()}</span>
                                    </div>
                                    <div className="flex items-center gap-3">
                                        <UserIcon className="fill-black" />
                                        <div className="max-w-32 whitespace-nowrap text-ellipsis overflow-hidden">
                                            <label className="text-sm">{tenant203.toUpperCase()}</label>
                                        </div>
                                    </div>
                                </div>
                                <div className="flex w-48 h-24 border-x-4 border-double">
                                    <div className={`${status201 === "Occupied" ? 'bg-slate-400' : ''} flex flex-col justify-center items-center w-24 h-24 border-t-4 border-r-4 border-double`}>
                                        <ShowerIcon />
                                        <span className="text-sm">Bathroom</span>
                                    </div>
                                    <div className={`${status202 === "Occupied" ? 'bg-slate-400' : ''} flex flex-col justify-center items-center w-24 h-24 border-b-4 border-l-4 border-double`}>
                                        <ShowerIcon />
                                        <span className="text-sm">Bathroom</span>
                                    </div>
                                </div>
                                <div className={`${status202 === "Occupied" ? 'bg-slate-400' : ''} flex flex-col justify-center items-center w-48 h-48 border-x-4 border-b-4 border-double`}>
                                    <span className="font-semibold text-2xl">202</span>
                                    <div>
                                        <span className="text-sm">{status202.toUpperCase()}</span>
                                    </div>
                                    <div className="flex items-center gap-3">
                                        <UserIcon className="fill-black" />
                                        <div className="max-w-32 whitespace-nowrap text-ellipsis overflow-hidden">
                                            <label className="text-sm">{tenant202.toUpperCase()}</label>
                                        </div>
                                    </div>
                                </div>
                                <div className={`${status201 === "Occupied" ? 'bg-slate-400' : ''} flex flex-col justify-center items-center w-48 h-48 border-y-4 border-r-4 border-double`}>
                                    <span className="font-semibold text-2xl">201</span>
                                    <div>
                                        <span className="text-sm">{status201.toUpperCase()}</span>
                                    </div>
                                    <div className="flex items-center gap-3">
                                        <UserIcon className="fill-black" />
                                        <div className="max-w-32 whitespace-nowrap text-ellipsis overflow-hidden">
                                            <label className="text-sm">{tenant201.toUpperCase()}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="w-16">
                                
                            </div>
                        </div>
                        <div className="h-[100px]">
                            
                        </div>
                    </div>
                </div>
            </div>

            <div className="flex justify-center gap-4 bg-white p-4">
                <div>
                    <span className="font-semibold text-xl">3rd Floor</span>

                    <div className="flex flex-col border-4 border-double mt-4">
                        <div className="flex">
                            <div className="w-24">
                                <div className="w-24 h-[1105px]">
                                </div>
                                <div className={`${status308 === "Occupied" ? 'bg-slate-400' : ''} flex flex-col justify-center items-center w-24 h-24 border-y-4 border-l-4 border-double`}>
                                    <ShowerIcon />
                                    <span className="text-sm">Bathroom</span>
                                </div>
                                <div className="w-24 h-24 border-r-4 border-double">
                                </div>
                            </div>

                            <div className="flex flex-col w-48 mt-12">
                                <div className={`${status312 === "Occupied" ? 'bg-slate-400' : ''} flex flex-col justify-center items-center w-48 h-48 border-x-4 border-t-4 border-double`}>
                                    <span className="font-semibold text-2xl">312</span>
                                    <div>
                                        <span className="text-sm">{status312.toUpperCase()}</span>
                                    </div>
                                    <div className="flex items-center gap-3">
                                        <UserIcon className="fill-black" />
                                        <div className="max-w-32 whitespace-nowrap text-ellipsis overflow-hidden">
                                            <label className="text-sm">{tenant312.toUpperCase()}</label>
                                        </div>
                                    </div>
                                </div>
                                <div className="flex w-48 h-24">
                                    <div className={`${status312 === "Occupied" ? 'bg-slate-400' : ''} flex flex-col justify-center items-center w-24 h-24 border-x-4 border-b-4 border-double`}>
                                        <ShowerIcon />
                                        <span className="text-sm">Bathroom</span>
                                    </div>
                                    <div className={`${status311 === "Occupied" ? 'bg-slate-400' : ''} flex flex-col justify-center items-center w-24 h-24 border-x-4 border-t-4 border-double`}>
                                        <ShowerIcon />
                                        <span className="text-sm">Bathroom</span>
                                    </div>
                                </div>
                                <div className={`${status311 === "Occupied" ? 'bg-slate-400' : ''} flex flex-col justify-center items-center w-48 h-48 border-x-4 border-b-4 border-double`}>
                                    <span className="font-semibold text-2xl">311</span>
                                    <div>
                                        <span className="text-sm">{status311.toUpperCase()}</span>
                                    </div>
                                    <div className="flex items-center gap-3">
                                        <UserIcon className="fill-black" />
                                        <div className="max-w-32 whitespace-nowrap text-ellipsis overflow-hidden">
                                            <label className="text-sm">{tenant311.toUpperCase()}</label>
                                        </div>
                                    </div>
                                </div>
                                <div className={`${status310 === "Occupied" ? 'bg-slate-400' : ''} flex flex-col justify-center items-center w-48 h-48 border-x-4 border-t-4 border-double`}>
                                    <span className="font-semibold text-2xl">310</span>
                                    <div>
                                        <span className="text-sm">{status310.toUpperCase()}</span>
                                    </div>
                                    <div className="flex items-center gap-3">
                                        <UserIcon className="fill-black" />
                                        <div className="max-w-32 whitespace-nowrap text-ellipsis overflow-hidden">
                                            <label className="text-sm">{tenant310.toUpperCase()}</label>
                                        </div>
                                    </div>
                                </div>
                                <div className="flex w-48 h-24">
                                    <div className={`${status310 === "Occupied" ? 'bg-slate-400' : ''} flex flex-col justify-center items-center w-24 h-24 border-x-4 border-b-4 border-double`}>
                                        <ShowerIcon />
                                        <span className="text-sm">Bathroom</span>
                                    </div>
                                    <div className={`${status309 === "Occupied" ? 'bg-slate-400' : ''} flex flex-col justify-center items-center w-24 h-24 border-x-4 border-t-4 border-double`}>
                                        <ShowerIcon />
                                        <span className="text-sm">Bathroom</span>
                                    </div>
                                </div>
                                <div className={`${status309 === "Occupied" ? 'bg-slate-400' : ''} flex flex-col justify-center items-center w-48 h-48 border-x-4 border-b-4 border-double`}>
                                    <span className="font-semibold text-2xl">309</span>
                                    <div>
                                        <span className="text-sm">{status309.toUpperCase()}</span>
                                    </div>
                                    <div className="flex items-center gap-3">
                                        <UserIcon className="fill-black" />
                                        <div className="max-w-32 whitespace-nowrap text-ellipsis overflow-hidden">
                                            <label className="text-sm">{tenant309.toUpperCase()}</label>
                                        </div>
                                    </div>
                                </div>

                                <div className="flex items-center justify-center w-48 h-24">
                                     
                                </div>

                                <div className={`${status308 === "Occupied" ? 'bg-slate-400' : ''} flex flex-col justify-center items-center w-48 h-48 border-r-4 border-y-4 border-double`}>
                                    <span className="font-semibold text-2xl">308</span>
                                    <div>
                                        <span className="text-sm">{status308.toUpperCase()}</span>
                                    </div>
                                    <div className="flex items-center gap-3">
                                        <UserIcon className="fill-black" />
                                        <div className="max-w-32 whitespace-nowrap text-ellipsis overflow-hidden">
                                            <label className="text-sm">{tenant308.toUpperCase()}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="w-48 mt-12">
                                <div className="flex items-center justify-center w-48 h-24 border-4 border-double">
                                    Tangga 
                                </div>
                                <div className={`${status306 === "Occupied" ? 'bg-slate-400' : ''} flex flex-col justify-center items-center w-48 h-48 border-x-4 border-t-4 border-double`}>
                                    <span className="font-semibold text-2xl">306</span>
                                    <div>
                                        <span className="text-sm">{status306.toUpperCase()}</span>
                                    </div>
                                    <div className="flex items-center gap-3">
                                        <UserIcon className="fill-black" />
                                        <div className="max-w-32 whitespace-nowrap text-ellipsis overflow-hidden">
                                            <label className="text-sm">{tenant306.toUpperCase()}</label>
                                        </div>
                                    </div>
                                </div>
                                <div className="flex w-48 h-48">
                                    <div className="flex flex-col w-24 h-48 border-l-4  border-double">
                                        <div className={`${status306 === "Occupied" ? 'bg-slate-400' : ''} flex flex-col justify-center items-center w-24 h-24 border-b-4 border-double`}>
                                            <ShowerIcon />
                                            <span className="text-sm">Bathroom</span>
                                        </div>
                                        <div className={`${status307 === "Occupied" ? 'bg-slate-400' : ''} flex flex-col justify-center items-center w-24 h-24 border-t-4 border-double`}>
                                            <ShowerIcon />
                                            <span className="text-sm">Bathroom</span>
                                        </div>
                                    </div>
                                    <div className="w-24 h-48 border-y-4 border-t-4 border-l-4 border-double">

                                    </div>
                                </div>
                                <div className={`${status307 === "Occupied" ? 'bg-slate-400' : ''} flex flex-col justify-center items-center w-48 h-48 border-x-4 border-b-4 border-double`}>
                                    <span className="font-semibold text-2xl">307</span>
                                    <div>
                                        <span className="text-sm">{status307.toUpperCase()}</span>
                                    </div>
                                    <div className="flex items-center gap-3">
                                        <UserIcon className="fill-black" />
                                        <div className="max-w-32 whitespace-nowrap text-ellipsis overflow-hidden">
                                            <label className="text-sm">{tenant307.toUpperCase()}</label>
                                        </div>
                                    </div>
                                </div>
                                <div className="flex w-48 h-48 border-4 border-double">
                                    Tangga
                                </div>
                                <div className="flex gap-2 items-center justify-center w-48 h-48">
                                    <TVIcon />
                                    <label>Ruang Bersama</label>
                                </div>
                                <div className="flex items-center justify-center w-48 h-24 border-4 border-double">
                                    Balkon
                                </div>
                            </div>
                            <div className="w-24">
                                <div className="flex items-center justify-center w-24 h-[1104px]">
                                    
                                </div>
                                <div className="flex flex-col items-center justify-center w-24 h-48 border-y-4 border-l-4 border-double">
                                    <div className={`${status301 === "Occupied" ? 'bg-slate-400' : ''} flex items-center justify-center w-24 h-24`}>
                                        
                                    </div>
                                    <div className={`${status301 === "Occupied" ? 'bg-slate-400' : ''} flex flex-col justify-center items-center w-24 h-24 border-y-4 border-l-4 border-double`}>
                                        <ShowerIcon />
                                        <span className="text-sm">Bathroom</span>
                                    </div>
                                </div>
                            </div>
                            <div className="w-48">
                                <div className="w-48 h-[144px]">
                                    
                                </div>
                                <div className={`${status305 === "Occupied" ? 'bg-slate-400' : ''} flex flex-col justify-center items-center w-48 h-48 border-x-4 border-t-4 border-double`}>
                                    <span className="font-semibold text-2xl">305</span>
                                    <div>
                                        <span className="text-sm">{status305.toUpperCase()}</span>
                                    </div>
                                    <div className="flex items-center gap-3">
                                        <UserIcon className="fill-black" />
                                        <div className="max-w-32 whitespace-nowrap text-ellipsis overflow-hidden">
                                            <label className="text-sm">{tenant305.toUpperCase()}</label>
                                        </div>
                                    </div>
                                </div>
                                <div className="flex w-48 h-24 border-x-4 border-double">
                                    <div className={`${status304 === "Occupied" ? 'bg-slate-400' : ''} flex flex-col justify-center items-center w-24 h-24 border-t-4 border-r-4 border-double`}>
                                        <ShowerIcon />
                                        <span className="text-sm">Bathroom</span>
                                    </div>
                                    <div className={`${status305 === "Occupied" ? 'bg-slate-400' : ''} flex flex-col justify-center items-center w-24 h-24 border-b-4 border-l-4 border-double`}>
                                        <ShowerIcon />
                                        <span className="text-sm">Bathroom</span>
                                    </div>
                                </div>
                                <div className={`${status304 === "Occupied" ? 'bg-slate-400' : ''} flex flex-col justify-center items-center w-48 h-48 border-x-4 border-b-4 border-double`}>
                                    <span className="font-semibold text-2xl">304</span>
                                    <div>
                                        <span className="text-sm">{status304.toUpperCase()}</span>
                                    </div>
                                    <div className="flex items-center gap-3">
                                        <UserIcon className="fill-black" />
                                        <div className="max-w-32 whitespace-nowrap text-ellipsis overflow-hidden">
                                            <label className="text-sm">{tenant304.toUpperCase()}</label>
                                        </div>
                                    </div>
                                </div>
                                <div className={`${status303 === "Occupied" ? 'bg-slate-400' : ''} flex flex-col justify-center items-center w-48 h-48 border-x-4 border-t-4 border-double`}>
                                    <span className="font-semibold text-2xl">303</span>
                                    <div>
                                        <span className="text-sm">{status303.toUpperCase()}</span>
                                    </div>
                                    <div className="flex items-center gap-3">
                                        <UserIcon className="fill-black" />
                                        <div className="max-w-32 whitespace-nowrap text-ellipsis overflow-hidden">
                                            <label className="text-sm">{tenant303.toUpperCase()}</label>
                                        </div>
                                    </div>
                                </div>
                                <div className="flex w-48 h-24 border-x-4 border-double">
                                    <div className={`${status302 === "Occupied" ? 'bg-slate-400' : ''} flex flex-col justify-center items-center w-24 h-24 border-t-4 border-r-4 border-double`}>
                                        <ShowerIcon />
                                        <span className="text-sm">Bathroom</span>
                                    </div>
                                    <div className={`${status303 === "Occupied" ? 'bg-slate-400' : ''} flex flex-col justify-center items-center w-24 h-24 border-b-4 border-l-4 border-double`}>
                                        <ShowerIcon />
                                        <span className="text-sm">Bathroom</span>
                                    </div>
                                </div>
                                <div className={`${status302 === "Occupied" ? 'bg-slate-400' : ''} flex flex-col justify-center items-center w-48 h-48 border-x-4 border-b-4 border-double`}>
                                    <span className="font-semibold text-2xl">302</span>
                                    <div>
                                        <span className="text-sm">{status302.toUpperCase()}</span>
                                    </div>
                                    <div className="flex items-center gap-3">
                                        <UserIcon className="fill-black" />
                                        <div className="max-w-32 whitespace-nowrap text-ellipsis overflow-hidden">
                                            <label className="text-sm">{tenant302.toUpperCase()}</label>
                                        </div>
                                    </div>
                                </div>
                                <div className={`${status301 === "Occupied" ? 'bg-slate-400' : ''} flex flex-col justify-center items-center w-48 h-48 border-y-4 border-r-4 border-double`}>
                                    <span className="font-semibold text-2xl">301</span>
                                    <div>
                                        <span className="text-sm">{status301.toUpperCase()}</span>
                                    </div>
                                    <div className="flex items-center gap-3">
                                        <UserIcon className="fill-black" />
                                        <div className="max-w-32 whitespace-nowrap text-ellipsis overflow-hidden">
                                            <label className="text-sm">{tenant301.toUpperCase()}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="w-16">                                
                            </div>
                        </div>
                        <div className="h-[100px]">                            
                        </div>
                    </div>
                </div>
            </div>
            
        </MainBodyCard>
    )
}